import axios from 'axios';
import { apiUrl } from '../Config';


const getAuthToken = () => {
    return (
        localStorage.getItem('token')
    );
}
export const companyDetailsApi = async (data) => {
    try {
        // Get token from localStorage
            const token = getAuthToken();

        // Create FormData for multipart/form-data
        const formData = new FormData();

        // Ensure all fields are appended, even if empty
        formData.append('name', data.name || '');
        formData.append('gstin', data.gstin || '');
        formData.append('website', data.website || '');
        formData.append('industryId', data.industryId || '');
        formData.append('companySize', data.companySize || '');
        formData.append('locationText', data.locationText || '');
        formData.append('foundedYear', data.foundedYear || '');

        // Get employerId from data or fallback to localStorage
        const employerId = data.employerId || localStorage.getItem('employerId');

        // Always append employerId if it exists
        if (employerId !== null && employerId !== undefined && employerId !== '') {
            formData.append('employerId', employerId);
        }

        // Append logo file if it exists
        if (data.logo) {
            formData.append('logo', data.logo);
        }



        const response = await axios.post(
            `${apiUrl}/companies/create`,
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Company details API error:', error);
        throw error;
    }
};



export const getCompanySettings = async () => {
    try {
        const token = getAuthToken();
        const response = await axios.get(`${apiUrl}/company/get`, {
            headers: { 'Authorization': `Bearer ${token}` }
        });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }

}

export const updateCompanySettings = async (companyId, data) => {
    try {
        const token = getAuthToken();
        // Axios will automatically set Content-Type:
        // - multipart/form-data with boundary for FormData
        // - application/json for regular objects
        const response = await axios.put(`${apiUrl}/company/update/${companyId}`, data, {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}